import * as constants from 'common/constants';
// import { field } from 'api';

export const updateSeason = payload => ({
  type: constants.UPDATE_SEASON,
  payload,
});

export const isUpdatingCropPrice = payload => ({
  type: constants.UPDATE_CROP_PRICE_STATUS,
  payload,
});

export const updateFeatures = payload => ({
  type: constants.UPDATE_FEATURES,
  payload,
});

export const updateNetworkStatus = payload => ({
  type: constants.UPDATE_NETWORK_STATUS,
  payload,
});

export const updateMaxPlantingArea = payload => ({
  type: constants.UPDATE_MAX_PLANTING_AREA,
  payload,
});



// WEBPACK FOOTER //
// ./src/actions/settings.js